export default class RequestPayload {
}
